import { useAppContext } from "@app/helpers/hooks";

import type { CarouselItem } from "./carousel";

export const useCarouselItems = () => {
  const { translator, urlBuilder } = useAppContext();

  const carouselItems: CarouselItem[] = [
    {
      illustration_src: urlBuilder.image(
        "/account/authentication/plan-illustration.svg"
      ),
      title: translator.t("!account.sign-up.create-account"),
      text: translator.t("!account.sign-up.create-account-description")
    },
    {
      illustration_src: urlBuilder.image(
        "/account/authentication/account-illustration.svg"
      ),
      title: translator.t("!account.sign-up.change-of-plans"),
      text: translator.t("!account.sign-up.change-of-plans-text")
    }
  ];

  return carouselItems;
};
